
if (!window.obelix) {
    throw "☠ obelix configuration missing";
}
if (!window.obelix.htmlSelector) {
    throw "☠ obelix.htmlSelector missing";
}

import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue';
import VueLogger from 'vuejs-logger';

const options = {
    isEnabled: true,
    logLevel: process.env.NODE_ENV === 'production' ? 'error' : 'info',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
};
Vue.use(VueLogger, options);

import VueCompositionApi from '@vue/composition-api';
Vue.use(VueCompositionApi);

import './plugins/bootstrap-vue'
import './plugins/vue-select'
import './plugins/translation'
import App from './App.vue';
import store from './store';
import router from './router'

import './config/fontawesome';

Vue.config.productionTip = false;


new Vue({
    router,
    render: h => h(App),
    store,
    beforeMount: function () {
        store.dispatch('setLanguage', window.obelix.language || 'fr');
    }
}).$mount(window.obelix.htmlSelector);

